<script setup lang="ts">
import { inject } from 'vue';
import { NxButton } from '../Button';
import { NxTooltip } from '../Tooltip';
import { stickyContainerGroupInjectionKey } from './internal';

const group = inject(stickyContainerGroupInjectionKey);
if (!group) {
  throw new Error('NxStickyContainerScrubber must be used inside an NxStickyContainerGroup');
}

const items = group.items;
const activeId = group.activeId;
</script>

<template>
  <nav class="nx-sticky-scrubber" aria-label="Section navigation">
    <ul class="nx-sticky-scrubber-list">
      <li v-for="item in items" :key="item.id" class="nx-sticky-scrubber-item">
        <NxTooltip :text="item.labelText" side="right">
          <!-- ~1.8rem square icon-only button (height="xs" → 29px). Active section
               is the filled-brand "default" variant; the rest are "outline". -->
          <NxButton
            height="xs"
            width="icon-only"
            :variant="activeId === item.id ? 'default' : 'outline'"
            :aria-label="item.labelText"
            :aria-current="activeId === item.id ? 'true' : undefined"
            tabindex="-1"
            style="border-radius: var(--nxt-radius-full)"
            @click="item.scrollIntoView()"
          >
            <span class="nx-sticky-scrubber-index" aria-hidden="true">
              {{ item.index }}
            </span>
          </NxButton>
        </NxTooltip>
      </li>
    </ul>
  </nav>
</template>

<style scoped>
.nx-sticky-scrubber {
  display: flex;
  padding: var(--nxt-space-sm);
}

.nx-sticky-scrubber-list {
  list-style: none;
  margin: 0;
  padding: 0;
  /* The global type reset sizes every bare <ul>/<p> at 16px medium. */
  font-size: var(--nxt-font-size-sm);
  font-weight: var(--nxt-font-weight-regular);
  display: flex;
  flex-direction: column;
  gap: var(--nxt-space-xs);
}

.nx-sticky-scrubber-item {
  display: block;
}

.nx-sticky-scrubber-item :deep(.tooltip-wrapper) {
  display: block;
}

/* Keep the index legible despite the xs button's 0.75rem base. */
.nx-sticky-scrubber-index {
  font-size: var(--nxt-font-size-sm);
  line-height: 100%;
}
</style>
